import DocViewShell from "@/components/DocViewShell";
import FiveForcesBlueprint from "@/components/blueprints/FiveForcesBlueprint";

export default function FiveForcesView() {
  return (
    <DocViewShell
      eyebrow="Porter's Five Forces"
      eyebrowClass="text-indigo-700"
      toolName="Porter's Five Forces"
      editPathFn={(id) => `/forces/${id}`}
      render={(doc) => <FiveForcesBlueprint doc={doc} />}
    />
  );
}
